// extracted by mini-css-extract-plugin
module.exports = {"rigsList":"SeeWhatsAvailable_rigsList__sO2FX","rigItem":"SeeWhatsAvailable_rigItem__O__9B"};